import React, { Component } from 'react'
import { CREATE_LABEL, DELETE_LABEL, LABELS_QUERY, UPDATE_LABEL, } from "../../queries/Queries"
import { IconButton } from '@mui/material';
import { FaLockOpen, FaLock, FaSortUp, FaSortDown } from "react-icons/fa";
import { useMutation, useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from '../elements/CircularProgressIndicator';
import { FaPlus, FaSave, FaTrash } from "react-icons/fa";
import Label from './Label';
import { AUTH_TOKEN } from '../../constants';
import { flattenStrapiData } from '../../utils/utilities';

class LabelList extends Component {
  state = {
    locked: true,
    error: "",
    columns: [
    {column: "id", direction: "asc"},
    {column: "title", direction: "asc"},
    {column: "accepted_categorization", direction: "asc"}
    ],
    sortBy: "id:asc"
  }

  handleLockChange(e) {
    this.setState({locked: !this.state.locked});
  }

  updateColumn(at) {
    let column = this.state.columns[at]

    column.direction = column.direction === 'asc' ? 'desc' : 'asc'
    let columns = this.state.columns
    columns[at] = column
    let sortBy =  column.column + ":" + column.direction
    this.setState({columns: columns,
      sortBy: sortBy})
  }

  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    if(!token) {
      return(
        <div>
          <span className="Error">You must be loged in first</span>
        </div>
      )
    }

    return (
      <div>
        <IconButton onClick={this.handleLockChange.bind(this)} >{this.state.locked ? <FaLock/> : <FaLockOpen/> }</IconButton>
        <br/>
        <div><span className="error">{this.state.error}</span></div>
        <GetList
          token={token} 
          locked={this.state.locked}
          updateColumn={this.updateColumn.bind(this)}
          columns={this.state.columns}
          sortBy={this.state.sortBy}
        />
      </div>
    )
  }
}

function GetList({locked, token, updateColumn, columns, sortBy}) {

  const {data, loading, error, refetch} = useQuery(LABELS_QUERY, {variables: {sortBy: sortBy}})
  
  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) return(<span className="error">Error in labels: {error.message}</span>)
  
  function sort(columnNumber) {
    updateColumn(columnNumber)
    refetch({variables: {sortBy: sortBy}})
  }

  function getArrow(direction) {
    return direction === "asc" ? <FaSortUp/> : <FaSortDown/>
  }

  let categories = data.categories.data
  let labels = data.labels.data
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th onClick={() => sort(0)}><div><h4>Id</h4>{getArrow(columns[0].direction)}</div></th>
          <th onClick={() => sort(1)}><div><h4>title</h4>{getArrow(columns[1].direction)}</div></th>
          <th onClick={() => sort(2)}><div><h4>accepted categorization</h4>{getArrow(columns[2].direction)}</div></th>
          <th><h4>categories</h4></th>
          {/* <th><h4>subcategories</h4></th>
          <th><h4>skills</h4></th>
          <th><h4>subskills</h4></th> */}
          {token && !locked &&
          <th><h4>Edit/Add</h4></th>}
          {token && !locked &&
          <th><h4>Delete</h4></th>}
        </tr>
      </thead>
      <tbody>
        {labels.map(label => {
          label = flattenStrapiData(label)
          return <Label 
          categories={categories}
          key={label.id} 
          locked={locked} 
          label={label}>
            <Delete refetch={() => refetch()}/>
            <Update refetch={() => refetch()}/>
          </Label>
        })}
        {!locked && <Label 
            locked={locked}>
          <Add refetch={() => refetch()}/>
        </Label>}
      </tbody>
    </table>
  )
}

function Add({state, refetch, cleanState}) {
  const [createLabel, {loading, error}] = useMutation(CREATE_LABEL)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Create Mutation Error: "+error.message)

  return (
      <IconButton onClick={e => createLabel({variables: {title: state.title}})
      .then(data => {
        cleanState()
        refetch()
      })
      .catch(e => alert("Execute Add Mutation Error: "+e))}><FaPlus/></IconButton>
  )
}

function Delete({id, refetch}) {
  const [deleteLabel, {loading, error}] = useMutation(DELETE_LABEL)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Delete Mutation Error: "+ error.message)
  return (
      <IconButton onClick={e => deleteLabel({variables: {id: id}})
      .then(data => refetch())
      .catch(e => alert("Execute Update Mutation Error: "+e))}><FaTrash/></IconButton>
  )
}

function Update({id, state, refetch}) {
  const [upadateLabel, {loading, error}] = useMutation(UPDATE_LABEL)

  if(loading) return(<CircularProgressIndicator size={60} />)
  if(error) alert("Update Mutation Error: "+ error.message)
  return (
      <IconButton onClick={e => upadateLabel({variables: {id: id, title: state.title, accepted_categorization: state.accepted_categorization, categories: state.categories.map(category => category.id) }})
      .then(data => refetch({variables: {sortBy: "id:asc"}}))
      .catch(e => alert("Execute Update Mutation Error: "+e))}><FaSave/></IconButton>
  )
}


export default LabelList